import { ReactNode } from 'react';
import classNames from 'classnames';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';

type ControlPosition = 'left' | 'right';

export function CollapseAnimationWrapper({
  collapsed,
  showControl,
  width,
  children,
  controlPosition = 'right',
  controlClick,
  transitionOff,
}: {
  collapsed: boolean;
  showControl: boolean;
  width: number;
  children: ReactNode;
  controlPosition?: ControlPosition;
  controlClick?: () => void;
  transitionOff?: boolean;
}) {
  return (
    <div
      className={classNames('relative border-neutral-200 h-full', {
        'pr-2 border-r': collapsed && controlPosition === 'right',
        'pl-2 border-l': collapsed && controlPosition === 'left',
        'transition-all': !transitionOff,
      })}
      style={{ width: collapsed ? 8 : width }}
    >
      {showControl && controlPosition === 'left' && (
        <CollapseControl collapsed={collapsed} controlPosition={controlPosition} controlClick={controlClick} />
      )}
      {children}
      {showControl && controlPosition === 'right' && (
        <CollapseControl collapsed={collapsed} controlPosition={controlPosition} controlClick={controlClick} />
      )}
    </div>
  );
}

function CollapseControl({
  collapsed,
  controlPosition,
  controlClick,
}: {
  collapsed: boolean;
  controlPosition: ControlPosition;
  controlClick?: () => void;
}) {
  return (
    <div
      className={classNames(
        'absolute !!! w-4 top-1/2 h-14 bg-white border flex items-center justify-center cursor-pointer shadow-md z-10',
        {
          'left-full rounded-r-md border-l-0': controlPosition === 'right',
          'right-full rounded-l-md border-r-0': controlPosition === 'left',
        }
      )}
      style={{ top: controlPosition === 'left' ? 'calc(50% - 42px)' : '50%' }}
      onClick={() => {
        if (controlClick) {
          controlClick();
        }
      }}
    >
      <div
        className={classNames('transition-all', {
          'rotate-180': (collapsed && controlPosition === 'right') || (!collapsed && controlPosition === 'left'),
        })}
      >
        <Icon icon={IconsMap.ARROW_2_LEFT} className="w-4 h-4" />
      </div>
    </div>
  );
}
